// Function to convert session code to sortable number
export const getSessionSortValue = (sessionId: string): number => {
  // Extract year and session type from session ID
  const match = sessionId.match(/^(\d{2})([R\d])$/);
  if (!match) return 0;

  const [, year, sessionType] = match;
  const yearNum = parseInt(year, 10);

  // Convert session type to number for sorting
  // R (Regular) = 0, 1st Special = 1, 2nd Special = 2, etc.
  let sessionNum = 0;
  if (sessionType === 'R') {
    sessionNum = 0;
  } else {
    sessionNum = parseInt(sessionType, 10);
  }

  // Create sortable value: YYSS (year + session number)
  // Higher values should appear first (descending order)
  return yearNum * 100 + sessionNum;
};

// Function to sort sessions by session code
export const sortSessionsByCode = <T extends { id: string; name: string; isDefault?: boolean }>(
  sessions: T[],
): T[] => {
  return [...sessions].sort((a, b) => {
    const aValue = getSessionSortValue(a.id);
    const bValue = getSessionSortValue(b.id);
    // Sort in descending order (newest/highest first)
    return bValue - aValue;
  });
};
